// extracted by mini-css-extract-plugin
export default {"required":"FormRequiredValueIcon_required__FnuWX"};